export const leaderboardDummyData = {
  "leaderboardDaily": [{
    "User_Rank": 1,
    "msisdn": "1912248513",
    "score": 42,
    "time_taken": 122,
    "round_number": 1,
    "date": "2025-10-27",
    "event_id": 34,
    "win": 1,
    "name": "Masud rana",
    "username": "1912248513",
    "avatar_id": 1,
    "avatar_img": "null"
  },
  {
    "User_Rank": 2,
    "msisdn": "1968194479",
    "score": 40,
    "time_taken": 118,
    "round_number": 1,
    "date": "2025-10-27",
    "event_id": 34,
    "win": 1,
    "name": "",
    "username": "1968194479",
    "avatar_id": null,
    "avatar_img": ""
  },
  {
    "User_Rank": 3,
    "msisdn": "1961493254",
    "score": 37,
    "time_taken": 109,
    "round_number": 1,
    "date": "2025-10-27",
    "event_id": 34,
    "win": 1,
    "name": "",
    "username": "1961493254",
    "avatar_id": null,
    "avatar_img": ""
  },
  {
    "User_Rank": 4,
    "msisdn": "1917451953",
    "score": 37,
    "time_taken": 126,
    "round_number": 1,
    "date": "2025-10-27",
    "event_id": 34,
    "win": 1,
    "name": "",
    "username": "1917451953",
    "avatar_id": null,
    "avatar_img": ""
  },
  {
    "User_Rank": 5,
    "msisdn": "1921710091",
    "score": 35,
    "time_taken": 133,
    "round_number": 1,
    "date": "2025-10-27",
    "event_id": 34,
    "win": 1,
    "name": "",
    "username": "1921710091",
    "avatar_id": null,
    "avatar_img": ""
  }],
  "leaderboardWeekly": [
    {
      "User_Rank": 1,
      "msisdn": "1912248522",
      "score": 45,
      "time_taken": 135,
      "round_number": 1,
      "date": "2025-10-27",
      "event_id": 34,
      "win": 1,
      "name": "Masud rana",
      "username": "1912248522",
      "avatar_id": 1,
      "avatar_img": "null"
    },
    {
      "User_Rank": 2,
      "msisdn": "1968194488",
      "score": 42,
      "time_taken": 128,
      "round_number": 1,
      "date": "2025-10-27",
      "event_id": 34,
      "win": 1,
      "name": "",
      "username": "1968194488",
      "avatar_id": null,
      "avatar_img": ""
    },
    {
      "User_Rank": 3,
      "msisdn": "1961493266",
      "score": 39,
      "time_taken": 119,
      "round_number": 1,
      "date": "2025-10-27",
      "event_id": 34,
      "win": 1,
      "name": "",
      "username": "1961493266",
      "avatar_id": null,
      "avatar_img": ""
    },
    {
      "User_Rank": 4,
      "msisdn": "1917451966",
      "score": 37,
      "time_taken": 126,
      "round_number": 1,
      "date": "2025-10-27",
      "event_id": 34,
      "win": 1,
      "name": "",
      "username": "1917451966",
      "avatar_id": null,
      "avatar_img": ""
    },
    {
      "User_Rank": 5,
      "msisdn": "1921710091",
      "score": 35,
      "time_taken": 133,
      "round_number": 1,
      "date": "2025-10-27",
      "event_id": 34,
      "win": 1,
      "name": "",
      "username": "1921710091",
      "avatar_id": null,
      "avatar_img": ""
    }
  ],
  "leaderboardTournament": [
    {
      "User_Rank": 1,
      "msisdn": "1912248531",
      "score": 48,
      "time_taken": 148,
      "round_number": 1,
      "date": "2025-10-27",
      "event_id": 34,
      "win": 1,
      "name": "Masud rana",
      "username": "1912248531",
      "avatar_id": 1,
      "avatar_img": "null"
    },
    {
      "User_Rank": 2,
      "msisdn": "1968194499",
      "score": 45,
      "time_taken": 138,
      "round_number": 1,
      "date": "2025-10-27",
      "event_id": 34,
      "win": 1,
      "name": "",
      "username": "1968194499",
      "avatar_id": null,
      "avatar_img": ""
    },
    {
      "User_Rank": 3,
      "msisdn": "1961493276",
      "score": 42,
      "time_taken": 129,
      "round_number": 1,
      "date": "2025-10-27",
      "event_id": 34,
      "win": 1,
      "name": "",
      "username": "1961493276",
      "avatar_id": null,
      "avatar_img": ""
    },
    {
      "User_Rank": 4,
      "msisdn": "1917451973",
      "score": 39,
      "time_taken": 139,
      "round_number": 1,
      "date": "2025-10-27",
      "event_id": 34,
      "win": 1,
      "name": "",
      "username": "1917451973",
      "avatar_id": null,
      "avatar_img": ""
    },
    {
      "User_Rank": 5,
      "msisdn": "1921710071",
      "score": 35,
      "time_taken": 133,
      "round_number": 1,
      "date": "2025-10-27",
      "event_id": 34,
      "win": 1,
      "name": "",
      "username": "1921710071",
      "avatar_id": null,
      "avatar_img": ""
    }
  ],
  "leaderboardBcs": [
    {
      "User_Rank": 1,
      "msisdn": "1912248587",
      "score": 47,
      "time_taken": 122,
      "round_number": 1,
      "date": "2025-10-27",
      "event_id": 34,
      "win": 1,
      "name": "Masud rana",
      "username": "1912248587",
      "avatar_id": 1,
      "avatar_img": "null"
    },
    {
      "User_Rank": 2,
      "msisdn": "1968194487",
      "score": 45,
      "time_taken": 128,
      "round_number": 1,
      "date": "2025-10-27",
      "event_id": 34,
      "win": 1,
      "name": "",
      "username": "1968194487",
      "avatar_id": null,
      "avatar_img": ""
    },
    {
      "User_Rank": 3,
      "msisdn": "1961493278",
      "score": 42,
      "time_taken": 109,
      "round_number": 1,
      "date": "2025-10-27",
      "event_id": 34,
      "win": 1,
      "name": "",
      "username": "1961493278",
      "avatar_id": null,
      "avatar_img": ""
    },
    {
      "User_Rank": 4,
      "msisdn": "1917451978",
      "score": 39,
      "time_taken": 139,
      "round_number": 1,
      "date": "2025-10-27",
      "event_id": 34,
      "win": 1,
      "name": "",
      "username": "1917451978",
      "avatar_id": null,
      "avatar_img": ""
    },
    {
      "User_Rank": 5,
      "msisdn": "1921710068",
      "score": 35,
      "time_taken": 133,
      "round_number": 1,
      "date": "2025-10-27",
      "event_id": 34,
      "win": 1,
      "name": "",
      "username": "1921710068",
      "avatar_id": null,
      "avatar_img": ""
    }
  ],
}